<script setup>
import { Head, router } from "@inertiajs/vue3";

import Datatables from "@/Shared/Tables/Datatables.vue";
import DatatableFooterWrapper from "@/Shared/Tables/DatatableFooterWrapper.vue";
import VAlert from "@/Shared/VAlert.vue";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import VButtonCreate from "@/Shared/HeaderButton/VButtonCreate";
import VModalForm from "./_partials/VModalForm.vue";
import { ref } from "vue";
import Swal from "sweetalert2";
import axios from "axios";
import VModalDetail from "./_partials/VModalDetail.vue";

let props = defineProps({
    users: Object,
    filters: Object,
    columns: Array,
    canCreate: Boolean,
    roles: Array,
    urlStore: String,
    urlIndex: String,
});

const isShowAlert = ref(true);
const isShowForm = ref(false);
const isShowDetail = ref(false);

const selectedUser = ref(null);

const urlSubmit = ref(props.urlStore);
const urlUpdateCreds = ref("");

const formType = ref("create");

const breadcrumbs = [
    {
        url: "#",
        label: "User Profile",
    },
];

const changePageLength = (value) => {
    getUser({ per_page: value });
};

const onFilter = (value) => {
    getUser({
        search_fields: value.search_fields,
        search_values: value.search_values,
        per_page: props.filters.per_page ?? 20,
        order_by: value.order_by,
        order_type: value.order_type,
    });
};

const getUser = (params) => {
    router.get(props.urlIndex, params, {
        preserveState: true,
        replace: true,
    });
};

const openFormAdd = () => {
    formType.value = "create";

    urlSubmit.value = props.urlStore;

    selectedUser.value = null;
    isShowForm.value = true;
    isShowAlert.value = false;
};

const closeForm = () => {
    selectedUser.value = null;
    isShowForm.value = false;
    isShowAlert.value = false;
};

const closeDetail = () => {
    selectedUser.value = null;
    isShowDetail.value = false;
    isShowAlert.value = false;
};

const onSave = () => {
    selectedUser.value = null;
    isShowForm.value = false;
    isShowAlert.value = true;
};

const removeAction = async (value) => {
    const result = await Swal.fire({
        icon: "warning",
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) {
        return false;
    }

    router.post(value.url, { _method: "DELETE" });
};

const editAction = async (value) => {
    const response = await axios.get(value.urlFetch);

    selectedUser.value = response.data.data;

    urlSubmit.value = value.urlSubmit;
    urlUpdateCreds.value = value.urlUpdateCreds;

    formType.value = "edit";

    isShowForm.value = true;
    isShowAlert.value = false;
};

const showAction = async (value) => {
    const response = await axios.get(value.url);

    selectedUser.value = response.data.data;

    isShowDetail.value = true;
    isShowAlert.value = false;
};

const actionClick = (value) => {
    if (value.type == "delete") {
        removeAction(value);
    }

    if (value.type == "edit") {
        editAction(value);
    }

    if (value.type == "show") {
        showAction(value);
    }
};
</script>

<template>
    <Head>
        <title>User Profile</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <VAlert v-if="!isShowForm && isShowAlert" />

        <div class="card">
            <div class="card-body">
                <div class="text-end mb-3" v-if="canCreate">
                    <VButtonCreate @onClick="openFormAdd">
                        Add User
                    </VButtonCreate>
                </div>

                <div class="dataTables_wrapper dt-bootstrap5">
                    <Datatables
                        :columns="columns"
                        :pagination="users"
                        :filters="filters"
                        @onFilter="onFilter"
                        @onActionClick="actionClick"
                    />
                    <DatatableFooterWrapper
                        :pagination="users.meta"
                        :filters="filters"
                        @onChange="changePageLength"
                    />
                </div>
            </div>
        </div>

        <VModalForm
            v-if="isShowForm"
            :user="selectedUser"
            :roles="roles"
            :urlSubmit="urlSubmit"
            :urlUpdateCreds="urlUpdateCreds"
            :type="formType"
            :method="formType == 'create' ? 'post' : 'put'"
            @onSave="onSave"
            @onCancel="closeForm"
        />

        <VModalDetail
            v-if="isShowDetail"
            :user="selectedUser"
            :roles="roles"
            @onCancel="closeDetail"
        />
    </div>
</template>
